import { Paper } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import styles from "./projects.module.css";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "../card_design/card";
import Card2 from "../card_design/card2";
import boggle from "./boggle.jpg";

function Projects() {
  const projects_title = "Projects";
  const work_title = "Work Experience";

  const RenderBox = (Box_Title, Image_Class) => {
    return (
      <div className>
        <h2>{Box_Title}</h2>
        <Paper className={Image_Class}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12}></Grid>
          </Grid>
        </Paper>
      </div>
    );
  };

  return (
    <Grid
      spacing={4}
      container
      container
      direction="column"
      justify="space-evenly"
      alignItems="center"
    >
      <Grid item>
      <Card2 />
      </Grid>
      <Grid item>
        <Card img_src={boggle} heading={"Test heading"} body={"test body"} />
      </Grid>
    </Grid>
  );
}

export default Projects;
